import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import axios from 'axios';
import API from '../../API';
import Autocomplete from 'react-autocomplete';
import ErrorText from './error-msg';
import './project-form-guest.css'; // Assuming you have a CSS file for styling
import { InputText } from "../../components/inputs/text-input";
import { Col, Row, Form, Container } from 'reactstrap';
import LocationSection from './location-section';
import Cookies from 'js-cookie';
import {Helmet} from "react-helmet";
import Main from "../../layout/main";
class ProjectFormGuest extends React.Component {
  INITIAL_ERROR_STATE = {
    projectName: '',
    projectDescription: '',
    location: '',
    files: '',
    state: '',
    city: '',
    street_name: '',
    address_line1: '',
    zip_code: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      props: props,
      projectName: '',
      projectDescription: '',
      location: '',
      files: null,
      state: '',
      city: '',
      street_name: '',
      address_line1: '',
      zip_code: '',
      loadingShow: false,
      errors: this.INITIAL_ERROR_STATE,
      overAllErrors: [],
      stateSuggestions: [],
      citySuggestions: [],
      stateName: "",
      selected_state: "",
      cityName: "",
      selected_city: "",
      selectedStateId: "",
      showAlert: false,
      selectedService: this.props.match?.params?.subId || null,
      currentStep: 0, // Track the current step
      projectId: new URLSearchParams(this.props.location.search).get('project_id') || 0, // Get project ID from URL query params
      questionList: [], // Questions for step 2
      selectedAddressId: null, // Selected address for location
      projectSubmitted: false,
      projectType: "",
      postedProjectId: "",
      project_post_type: 0,
      customer_name: Cookies.get('name') || '',
      isEditMode: !!new URLSearchParams(this.props.location.search).get('project_id'), // Flag to track if we're in edit mode
      start_date: '',
      end_date: '',
      start_time: '',
      end_time: '',
      address_id: null,
    };
    console.log(this.state.selectedService,'selectedService');
    // Bind methods
    this.handleSubmitStep1 = this.handleSubmitStep1.bind(this);
    this.handleSubmitStep2 = this.handleSubmitStep2.bind(this);
    this.handleSubmitStep3 = this.handleSubmitStep3.bind(this);
    this.goBackHandler = this.goBackHandler.bind(this);
    this.fileUploadHandler = this.fileUploadHandler.bind(this);
    this.removeFiles = this.removeFiles.bind(this);
    this.handleServiceSelect = this.handleServiceSelect.bind(this);
    this.fetchProjectData = this.fetchProjectData.bind(this);
  }

  componentDidMount() {
    // Fetch categories if needed
    this.fetchCategories();
    
    // If in edit mode, fetch project data
    if (this.state.isEditMode && this.state.projectId) {
      this.fetchProjectData(this.state.projectId);
    }
    
    // Pre-fill project name if empty
    // if (!this.state.projectName) {
    //   this.setState({
    //     projectName: `${this.state.customer_name}'s ${this.state.projectType || 'Project'}`
    //   });
    // }
  }

  fetchCategories() {
    // Example of fetching categories from API
    axios.get(`${API.baseURL}/project_sub_types?projecttype_id=${this.props.match?.params?.id}`, API.options)
      .then(response => {
        const res = response.data;
        console.log(res,'ass');
        if (res.project_sub_types && res.project_sub_types.length > 0) {
          this.setState({
            categories: res.project_sub_types,
            projectType: res.title,
            projectName: `${this.state.customer_name.trim()}'s ${res.title || 'Project'}`
          });
        }
      })
      .catch(error => {
        console.error("Error fetching categories:", error);
      });
  }

  // Fetch project data for editing
  fetchProjectData(id) {
    this.setState({ loadingShow: true });
    
    axios
      .get(`${API.baseURL}/projects/${new URLSearchParams(this.props.location.search).get('project_id')}/edit`, API.options)
      .then(response => response.data)
      .then(res => {
        this.setState({
          projectName: res.name || '',
          projectDescription: res.description || '',
          selectedService: res.project_sub_type_id,
          selectedAddressId: res.address_id,
          start_date: res.start_date,
          end_date: res.end_date,
          start_time: res.start_time,
          end_time: res.end_time,
          address_id: res.address_id,
          project_post_type: res.project_post_type,
          files: res.documents || null, // Assuming documents are returned in compatible format
          loadingShow: false
        });
      })
      .catch(error => {
        console.error("Error fetching project data:", error);
        this.setState({ 
          loadingShow: false,
          overAllErrors: ['Failed to load project data. Please try again.']
        });
      });
  }

  // Step 1: Submit basic project info
  handleSubmitStep1(event) {
    if (event) event.preventDefault();
    
    // Validate form
    let errors = { ...this.INITIAL_ERROR_STATE };
    let hasErrors = false;

    if (this.state.projectName.trim() === "") {
      errors.projectName = 'Enter your Project Name!';
      hasErrors = true;
    }
    
    if (this.state.selectedService === null) {
      errors.serviceCategory = 'Please select a service category!';
      hasErrors = true;
    }
    
    if (this.state.projectDescription.trim() === "") {
      errors.projectDescription = 'Enter if you have any information!';
      hasErrors = true;
    }

    if (hasErrors) {
      this.setState({ errors });
      return;
    }

    this.setState({ loadingShow: true });

    // Create FormData for project
    let formData = new FormData();
    formData.append('project[name]', this.state.projectName);
    formData.append('project[description]', this.state.projectDescription);
    formData.append('project[project_type_id]', this.props.match?.params?.id);
    formData.append('project[project_sub_type_id]', this.state.selectedService);
    
    if (this.state.start_date) formData.append('project[start_date]', this.state.start_date);
    if (this.state.end_date) formData.append('project[end_date]', this.state.end_date);
    if (this.state.start_time) formData.append('project[start_time]', this.state.start_time);
    if (this.state.end_time) formData.append('project[end_time]', this.state.end_time);

    let request;
    
    // Determine if creating or updating
    if (this.state.isEditMode) {
      // Update existing project
      request = axios.patch(
        `${API.baseURL}/v2/customers/projects/${this.state.projectId}`, 
        formData, 
        {
          ...API.options,
          headers: {
            ...API.options.headers,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    } else {
      // Create new project
      request = axios.post(
        `${API.baseURL}/v2/customers/projects`, 
        formData, 
        {
          ...API.options,
          headers: {
            ...API.options.headers,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    }

    request
      .then(response => {
        const projectId = response.data.id || this.state.projectId;
        
        // If there are files, upload them separately
        if (this.state.files && this.state.files.length > 0) {
          const documentsFormData = new FormData();
          
          for (let i = 0; i < this.state.files.length; i++) {
            if (this.state.files[i].blob) {
              documentsFormData.append('documents[]', this.state.files[i].blob);
            }
          }
          
          // Upload documents using query parameter format
          return axios.post(
            `${API.baseURL}/projects/${projectId}/upload_project_documents`,
            documentsFormData,
            {
              ...API.options,
              headers: {
                ...API.options.headers,
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(() => response); // Return original response to maintain chain
        }
        return response;
      })
      .then(response => {
        // For edit mode, we might want to skip to location step
        const nextStep = this.state.isEditMode ? 2 : 
                        (response.data.questions && response.data.questions.length > 0) ? 1 : 2;
        
        this.setState({
          loadingShow: false,
          projectId: response.data.id || this.state.projectId,
          questionList: response.data.questions || [],
          currentStep: nextStep
        });
      })
      .catch(error => {
        console.error("Error:", error);
        this.setState({ 
          loadingShow: false,
          overAllErrors: ['Failed to save project or upload documents. Please try again.']
        });
      });
  }

  // Step 2: Submit project details/questions
  handleSubmitStep2(answers) {
    this.setState({ loadingShow: true });

    let data = JSON.stringify({ answers });

    axios.post(
      API.baseURL + `/projects/${this.state.projectId}/save_question_answers.json`,
      data,
      API.options
    )
    .then(result => {
      this.setState({ 
        loadingShow: false,
        currentStep: 2
      });
    })
    .catch(error => {
      console.error("Error saving answers:", error);
      this.setState({ 
        loadingShow: false,
        overAllErrors: ['Failed to save answers. Please try again.']
      });
    });
  }

  // Step 3: Save or publish project
  handleSubmitStep3(status) {
    if (!this.state.selectedAddressId) {
      this.setState({
        errors: {
          ...this.state.errors,
          location: 'Please select a location'
        }
      });
      return;
    }

    this.setState({ 
      loadingShow: true,
      project_post_type: 1 // Default post type
    });

    let data = JSON.stringify({
      project: {
        address_id: this.state.selectedAddressId,
        status: status // 0 for draft, 2 for publish
      }
    });

    axios.patch(
      API.baseURL + `/v2/customers/projects/${this.state.projectId}`,
      data,
      API.options
    )
    .then(result => {
      this.setState({ 
        loadingShow: false,
        projectSubmitted: true,
        postedProjectId: this.state.projectId,
        currentStep: status === '2' ? 4 : 3 // Step 4 for success, 3 for draft
      });
    })
    .catch(error => {
      console.error("Error finalizing project:", error);
      this.setState({ 
        loadingShow: false,
        overAllErrors: ['Failed to save project. Please try again.']
      });
    });
  }

  // Handle file upload
  fileUploadHandler(e) {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    files.forEach(file => {
      // Check file size (limit to 10MB)
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > 10) {
        this.setState({
          errors: {
            ...this.state.errors,
            files: 'File size exceeds 10MB'
          }
        });
        return;
      }

      // Create file object
      const fileObj = {
        blob: file,
        url: URL.createObjectURL(file),
        type: file.type.startsWith('image/') ? 'image' : 'document',
        where: 'local'
      };

      // Add to files array
      this.setState(prevState => ({
        files: prevState.files ? [...prevState.files, fileObj] : [fileObj],
        errors: {
          ...prevState.errors,
          files: ''
        }
      }));
    });
  }

  // Remove uploaded file
  removeFiles(index) {
    const filesArray = [...this.state.files];
    filesArray.splice(index, 1);
    this.setState({ files: filesArray.length > 0 ? filesArray : null });
  }

  // Handle address selection
  handleAddressSelect = (addressId) => {
    this.setState({ 
      selectedAddressId: addressId,
      errors: {
        ...this.state.errors,
        location: ''
      }
    });
  }

  // Handle service selection
  handleServiceSelect = (serviceId) => {
    this.setState({ 
      selectedService: serviceId,
      errors: {
        ...this.state.errors,
        serviceCategory: ''
      }
    });
    
    // If you need to update project_type based on selection
    const selectedCategory = this.state?.categories?.find(cat => cat.id === serviceId);
    if (selectedCategory) {
      this.setState({
        projectType: selectedCategory.title,
        // projectName: `${this.state.customer_name}'s ${selectedCategory.title}`
      });
    }
  }

  // Go back handler
  goBackHandler() {
    if (this.state.currentStep > 0) {
      this.setState(prevState => ({
        currentStep: prevState.currentStep - 1
      }));
    }
  }

  render() {
    const { currentStep, projectSubmitted, postedProjectId } = this.state;
    
    // Redirect after submission if needed
    if (projectSubmitted && currentStep === 4) {
      return <Redirect to={`/success/${postedProjectId}?project_type=${this.state.projectType}`} />;
    }
    
    if (projectSubmitted && currentStep === 3) {
      return <Redirect to="/dashboard/projects" />;
    }
console.log("Error",this.state.errors);

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8"/>
          <meta name="description"
                content="Check out all your Data about EasyBids at a single place.The projects you bidded,avaible projects around locality  and the bids approved.Check everything at a single place"/>
          <title>EasyBids - Home Improvements :: Post Your Project</title>
        </Helmet>
        <Main additionalClass_main="dashboard pt-0">
          <section className="ebw-section__pages">
            <Container>
              <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                  {/* Step 1: Basic Project Info */}
                  {currentStep === 0 && (
                      <div className="form-step-1">
                        <Form onSubmit={this.handleSubmitStep1}>
                          {/* Project Name */}
                          <div className="form-card mb-4">
                            <h5 className="card-title">Project Name</h5>
                            <div className="form-input-container">
                              <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter project name"
                                  value={this.state.projectName}
                                  onChange={(e) => this.setState({projectName: e.target.value})}
                              />
                              {this.state.errors.projectName && (
                                  <ErrorText text={this.state.errors.projectName}/>
                              )}
                            </div>
                          </div>

                          {/* Service Type Selection */}
                          <div className="form-card mb-4">
                            <h5 className="card-title">Service Category</h5>
                            <div className="service-selection">
                              <div className="d-flex flex-wrap justify-content-center" style={{gap: 20}}>
                                {this.state.categories?.length > 0 ? (
                                    this.state.categories?.map(category => (
                                        <div
                                            key={category.id}
                                            className={`service-item ${Number(this.state.selectedService) === category.id ? 'selected' : ''}`}
                                            onClick={() => this.handleServiceSelect(category.id)}
                                        >
                                          <div className="service-icon-wrapper">
                                            <img
                                                src={category.image?.url || "/assets/images/services/default.jpg"}
                                                alt={category.name}
                                            />
                                          </div>
                                          <span className="service-label">{category.name}</span>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-services">No services available</div>
                                )}
                              </div>
                            </div>
                            {this.state.errors.serviceCategory && (
                                <ErrorText text={this.state.errors.serviceCategory}/>
                            )}
                          </div>

                          {/* Project Description */}
                          <div className="form-card mb-4">
                            <h5 className="card-title">Enter if you have any information</h5>
                            <div className="form-input-container">
                            <textarea
                                className="form-control"
                                placeholder="Enter if any information here..."
                                rows="6"
                                value={this.state.projectDescription}
                                onChange={(e) => this.setState({projectDescription: e.target.value})}
                            ></textarea>
                              {this.state.errors.projectDescription && (
                                  <ErrorText text={this.state.errors.projectDescription}/>
                              )}
                            </div>
                          </div>

                          {/* File Upload */}
                          <div className="form-card mb-4">
                            <h5 className="card-title">Upload Picture and Videos</h5>
                            <p className="file-upload-hint">Upload a picture to get attention to your project</p>

                            <div className="file-upload-container">
                              {this.state.files && this.state.files.length > 0 && (
                                  <div className="uploaded-files mb-3">
                                    <div className="row">
                                      {this.state.files.map((file, index) => (
                                          <div key={index} className="col-4 col-md-2 mb-2">
                                            <div className="uploaded-file-item">
                                              {file.type === 'image' ? (
                                                  <img src={file.url} alt="Uploaded" className="img-fluid thumbnail"/>
                                              ) : (
                                                  <div className="document-icon">
                                                    <i className="fa fa-file-o"></i>
                                                  </div>
                                              )}
                                              <button
                                                  type="button"
                                                  className="btn-remove-file"
                                                  onClick={() => this.removeFiles(index)}
                                              >
                                                &times;
                                              </button>
                                            </div>
                                          </div>
                                      ))}
                                    </div>
                                  </div>
                              )}

                              <div className="file-upload-actions">
                                <button
                                    type="button"
                                    className="btn-upload"
                                    onClick={() => document.getElementById('capture-image').click()}
                                >
                                  <i className="fa fa-camera"></i> Upload Pictures
                                </button>

                                <button
                                    type="button"
                                    className="btn-upload"
                                    onClick={() => document.getElementById('upload-video').click()}
                                >
                                  <i className="fa fa-video-camera"></i> Upload Videos
                                </button>

                                <input
                                    id="capture-image"
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={this.fileUploadHandler}
                                    style={{display: 'none'}}
                                />

                                <input
                                    id="upload-video"
                                    type="file"
                                    accept="video/*"
                                    multiple
                                    onChange={this.fileUploadHandler}
                                    style={{display: 'none'}}
                                />
                              </div>

                              {this.state.errors.files && (
                                  <ErrorText text={this.state.errors.files}/>
                              )}
                            </div>
                          </div>

                          {/* Continue Button */}
                          <div className="continue-button-container">
                            <button
                                type="submit"
                                className="btn-continue"
                                disabled={this.state.loadingShow || !this.state.projectDescription.trim()}
                                style={{
                                  backgroundColor: (this.state.loadingShow || !this.state.projectDescription.trim()) ? undefined : '#4CAF50'
                                }}
                            >
                              {this.state.loadingShow ? 'Processing...' : 'CONTINUE'}
                            </button>
                          </div>
                        </Form>
                      </div>
                  )}

                  {/* Step 2: Project Questions (if any) */}
                  {currentStep === 1 && (
                      <div className="form-step-2">
                        <div className="form-card mb-4">
                          <h5 className="card-title">Project Details</h5>
                          <p className="mb-4">Please answer these questions about your project:</p>

                          {this.state.questionList.map((question, index) => (
                              <div key={index} className="question-item mb-3">
                                <label>{question.name} {question.is_mandatory &&
                                    <span className="text-danger">*</span>}</label>

                                {/* Render different input types based on question_type */}
                                {question.question_type === 1 && (
                                    <textarea
                                        className="form-control"
                                        placeholder="Your answer"
                                        required={question.is_mandatory}
                                    ></textarea>
                                )}

                                {question.question_type === 2 && (
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Your answer"
                                        required={question.is_mandatory}
                                    />
                                )}

                                {/* Add other question types as needed */}
                              </div>
                          ))}

                          <div className="continue-button-container">
                            <button
                                type="button"
                                className="btn-back mr-2"
                                onClick={this.goBackHandler}
                            >
                              Back
                            </button>
                            <button
                                type="button"
                                className="btn-continue"
                                onClick={() => this.handleSubmitStep2([])} // Simplified for now
                                disabled={this.state.loadingShow}
                            >
                              {this.state.loadingShow ? 'Processing...' : 'CONTINUE'}
                            </button>
                          </div>
                        </div>
                      </div>
                  )}

                  {/* Step 3: Location and Project Posting */}
                  {currentStep === 2 && (
                      <div className="form-step-3">
                        <div className="location-card mb-4">
                          <LocationSection
                              onAddressSelect={this.handleAddressSelect}
                              selectedAddressId={this.state.selectedAddressId}
                          />

                          {this.state.errors.location && (
                              <ErrorText text={this.state.errors.location}/>
                          )}
                        </div>

                        <div className="action-buttons">
                          <button
                              type="button"
                              className="btn-save-draft"
                              onClick={() => this.handleSubmitStep3('0')}
                              disabled={this.state.loadingShow}
                          >
                            Save as Draft
                          </button>
                          <button
                              type="button"
                              className="btn-post"
                              onClick={() => this.handleSubmitStep3('2')}
                              disabled={this.state.loadingShow || !this.state.selectedAddressId}
                          >
                            Publish Now
                          </button>
                        </div>
                      </div>
                  )}

                  {/* Loading overlay */}
                  {this.state.loadingShow && (
                      <div className="loading-overlay">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                  )}

                  {/* Success message overlay */}
                  {this.state.showAlert && (
                      <div className="alert-overlay">
                        <div className="alert-box">
                          <h3>Project Created!</h3>
                          <p>Project created successfully. Login/Signup to make your project live.</p>
                          <button
                              onClick={() => {
                                this.setState({showAlert: false});
                                window.location.href = "/login";
                              }}
                          >
                            Done
                          </button>
                        </div>
                      </div>
                  )}
                </Col>
              </Row>
            </Container>
          </section>
        </Main>
      </div>
    );
  }
}

export default ProjectFormGuest;